<template>
  <div class="location-avatar" :class="{ 'location-avatar--gray': props.placeholderTone === 'gray' }">
    <img v-if="imageSrc && !imageFailed" :src="imageSrc" :alt="props.name" @error="imageFailed = true" />
    <IconEmbedded v-else name="map-pin_1-5" :size="Math.round(props.size * 0.55)" color="currentColor" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = withDefaults(
  defineProps<{
    src?: string | null;
    name?: string;
    size?: number;
    placeholderTone?: "teal" | "gray";
  }>(),
  { src: null, name: "Location", size: 48, placeholderTone: "gray" }
);

const imageFailed = ref(false);
watch(
  () => props.src,
  () => (imageFailed.value = false)
);

const imageSrc = computed(() => {
  const value = props.src?.trim();
  if (!value) return "";
  if (/^(https?:|data:|blob:)/i.test(value)) return value;
  const contentBaseUri = globalThis.Bootstrap?.Config?.contentCdnBaseUri ?? "";
  if (!contentBaseUri) return value;
  const iconId = value.replace(/^\/+/, "");
  return `${contentBaseUri.replace(/\/$/, "")}/cms/images/expeditions/location-icons/${iconId}`;
});
</script>

<style scoped lang="scss">
.location-avatar {
  width: v-bind("`${props.size}px`");
  height: v-bind("`${props.size}px`");
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  overflow: hidden;
  border-radius: 999px;
  color: white;
  background: #176c62;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &--gray {
    color: #667085;
    background: #e4e7ec;
  }
}
</style>
